import React from 'react';
import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';
import { getIncreaseDecreaseValue } from '../helpers/helpers';
import { displayInfo } from '../constants/dashboards';

const Card = ({ card, chartProps, dashboardData, isPDF }) => {
    const { formatter, keyField, title, labelUnitType = '', changeFormatter = formatter } = card;

    const beginPeriodData = dashboardData[0]?.[keyField];
    const endPeriodData = dashboardData[1]?.[keyField];

    const shouldShowEmptyCard = !beginPeriodData || !endPeriodData;

    const titleClassNames = 'helix-text-gray-500 mb-0';
    const bodyClassNames = 'helix-text-gray-500 helix-body--strong mb-0';

    return (
        <div className={`card-wrapper content mb-3 px-4 pt-4 ${shouldShowEmptyCard ? 'card-wrapper--empty' : ''} ${isPDF ? 'dashboard-card' : 'card-wrapper--responsive'}`}>
            <h5 className='mb-0 title'>{title}</h5>
            {shouldShowEmptyCard
                ? <div className='d-flex flex-column justify-content-center align-items-center w-100 h-100 px-2'>
                    <h4 className={`${titleClassNames} text-center mb-2`} style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>{displayInfo.noDataToDisplayTitle}</h4>
                    <p className={`${bodyClassNames} text-center`} style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>{displayInfo.noDataToDisplayMessage}</p>
                </div>
                : <>
                    <h3 className={titleClassNames}>{`${formatter(endPeriodData)} ${labelUnitType}`}</h3>
                    <p className={`${bodyClassNames} ${isPDF ? 'percentage' : ''}`}>
                        {getIncreaseDecreaseValue({
                            beginPeriodData: dashboardData[0],
                            endPeriodData: dashboardData[1],
                            formatter,
                            keyField,
                            changeFormatter,
                            isOverview: true,
                        })}
                    </p>
                    <div id='chart-wrapper'>
                        <Chart type='bar' {...chartProps} />
                    </div>
                </>
            }
        </div>
    );
};

Card.propTypes = {
    card: PropTypes.object,
    chartProps: PropTypes.object,
    dashboardData: PropTypes.array,
    isPDF: PropTypes.bool.isRequired,
};

export default Card;
